<template>
  <div v-if="calls.length" class="therapist-call-anchor" aria-live="assertive">
    <transition-group name="call-banner" tag="div" class="therapist-call-stack">
      <div
        v-for="item in calls"
        :key="item.therapist_call_id"
        class="therapist-call-popup"
      >
        <span class="call-popup-icon" aria-hidden="true">!</span>
        <div class="call-popup-body">
          <div class="call-popup-title">治疗师请求协助</div>
          <div class="call-popup-room">{{ item.room_name || '—' }}</div>
          <p v-if="item.content" class="call-popup-content">{{ item.content }}</p>
          <div v-if="item.caller_staff_name || item.scheduled_staff_name" class="call-popup-meta">
            <span v-if="item.caller_staff_name">呼叫 {{ item.caller_staff_name }}</span>
            <span v-if="item.caller_staff_name && item.scheduled_staff_name" class="call-popup-dot">·</span>
            <span v-if="item.scheduled_staff_name">治疗师 {{ item.scheduled_staff_name }}</span>
          </div>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: 'TherapistCallBanner',
  props: {
    calls: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
/* 居中浮层弹窗：不遮罩整屏，不阻挡大屏内容浏览 */
.therapist-call-anchor {
  position: fixed;
  left: 50%;
  top: 50%;
  z-index: 9999;
  transform: translate(-50%, -50%);
  pointer-events: none;
  max-width: min(400px, 88vw);
  max-height: 70vh;
}

.therapist-call-stack {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
  max-height: 70vh;
  overflow-y: auto;
}

.therapist-call-popup {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 12px;
  color: #fff;
  text-align: left;
  box-shadow:
    0 8px 28px rgba(0, 18, 46, 0.28),
    0 0 0 1px rgba(255, 183, 77, 0.4);
  background: linear-gradient(
    135deg,
    rgba(255, 167, 38, 0.96) 0%,
    rgba(245, 124, 0, 0.94) 100%
  );
  border: 1px solid rgba(255, 224, 178, 0.65);
  animation: call-popup-attention 2s ease-in-out infinite;
}

@keyframes call-popup-attention {
  0%, 100% { box-shadow: 0 8px 28px rgba(0, 18, 46, 0.28), 0 0 0 1px rgba(255, 183, 77, 0.4); }
  50% { box-shadow: 0 10px 32px rgba(230, 81, 0, 0.35), 0 0 0 2px rgba(255, 224, 178, 0.55); }
}

.call-popup-icon {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  font-size: 18px;
  font-weight: 800;
  line-height: 1;
  color: #e65100;
  background: rgba(255, 255, 255, 0.95);
}

.call-popup-body {
  flex: 1;
  min-width: 0;
}

.call-popup-title {
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.06em;
  margin-bottom: 4px;
  opacity: 0.95;
  color: rgba(255, 255, 255, 0.95);
}

.call-popup-room {
  font-size: 22px;
  font-weight: 800;
  line-height: 1.25;
  margin-bottom: 4px;
  color: #fff;
  text-shadow: 0 1px 4px rgba(0, 18, 46, 0.2);
}

.call-popup-content {
  margin: 0 0 6px;
  font-size: 13px;
  line-height: 1.4;
  opacity: 0.92;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.call-popup-meta {
  font-size: 12px;
  line-height: 1.35;
  opacity: 0.9;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.call-popup-dot {
  margin: 0 4px;
  opacity: 0.7;
}

.call-banner-enter-active,
.call-banner-leave-active {
  transition: all 0.35s ease;
}

.call-banner-enter,
.call-banner-leave-to {
  opacity: 0;
  transform: scale(0.92) translateY(8px);
}

.call-banner-move {
  transition: transform 0.35s ease;
}
</style>
